export default __webpack_public_path__ + "static/media/blog-oliva2.d7f12ffc.jpg";